module.exports = __webpack_public_path__ + "collaboration.66e78315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/notifications/collaboration.png
// module id = 1502
// module chunks = 0